<template>
  <div
    class="modal fade"
    id="assignLoanOfficerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="assignLoanOfficerModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="assignLoanOfficerModalLabel"
          >
            {{ $t('string.assignLoanOfficer') }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            class="form-group"
            :class="{'has-error' : validations['loan_officer_id']}"
          >
            <label
              for="loanOfficers"
              class="required"
            >{{ $t('string.loanOfficer') }}</label>
            <multiselect
              v-model="params.loan_officers"
              :options="loanOfficers"
              id="loanOfficers"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :deselect-label="$t('string.press_enter_to_remove')"
              :select-label="$t('string.press_enter_to_select')"
              :selected-label="$t('string.multiple_select_selected')"
              :placeholder="$t('string.chooseLoanOfficers')"
              label="name"
              track-by="id"
            />
            <template v-if="validations['loan_officer_id']">
              <span class="help-block">{{ validations['loan_officer_id'][0] }}</span>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="onSave"
            :disabled="isSaveWaiting"
            class="btn btn-primary"
          >
            <i
              class="fa fa-spinner fa-spin"
              v-if="isSaveWaiting"
            /> {{ $t('button.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AssignLoanOfficerModal',
  data () {
    return {
      loanOfficers: [],
      validations: {},
      params: {
        loan_officers: null,
        borrow_id: null
      },
      isSaveWaiting: false
    }
  },
  computed: {
    ...mapState({
      borrow_id: state => state.loanOfficerAssignment.borrow_id,
      toggle_assign_loan_officer_modal: state => state.loanOfficerAssignment.toggle_assign_loan_officer_modal
    })
  },
  watch: {
    toggle_assign_loan_officer_modal () {
      if (this.borrow_id) {
        this.params.borrow_id = this.borrow_id
        this.getLoanOfficersBelongToThisBorrower()
      }
    }
  },
  methods: {
    onResetForm () {
      this.validations = {}
      this.params = {
        loan_officers: null,
        borrow_id: null
      }
      this.$refs.close.click()
    },
    onSave () {
      this.isSaveWaiting = true
      this.$axios.post(this.$base_api + '/api/v4/backend/assign-loan-officer/create', this.params)
        .then(({ data }) => {
          if (data.data) {
            this.$emit('refreshList')
            this.onResponseSuccess()
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getLoanOfficerList () {
      this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment/loan-officer-list')
        .then(({ data }) => {
          if (data.data) {
            this.loanOfficers = data.data.map((user) => {
              return {
                id: user.id,
                name: user.name
              }
            })
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getLoanOfficersBelongToThisBorrower () {
      this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment/get-loan-officers-belong-to-this-borrower', {
        borrow_id: this.params.borrow_id
      })
        .then(({ data }) => {
          if (data.data) {
            this.params.loan_officers = data.data.map((user) => {
              return {
                id: user.id,
                name: user.name
              }
            })
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    }
  },
  mounted () {
    this.getLoanOfficerList()
  }
}
</script>

<style scoped>

</style>
